import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import dayjs from '../dayjs.service';
import { environment } from '@env/environment';
import { ApiService } from '../api.service';
import { CompaniesService } from '@services/companies.service';

@Injectable({ providedIn: 'root' })
export class LegalTermsService {
  constructor(
    private apiService: ApiService,
    private jwtHelperService: JwtHelperService,
    private router: Router,
    private location: Location,
    private companiesService: CompaniesService,
  ) {}

  public getLegalTermsLastUpdatedDate(): Observable<string> {
    return this.apiService.get<string>(`${environment.url.prefixIdentity}legal-terms/update-date`);
  }

  public acceptLegalTerms(): Observable<void> {
    return this.apiService.post<void>(`${environment.url.prefixIdentity}legal-terms/accepted-date`);
  }

  public getPrivacyPolicyLastUpdatedDate(): Observable<string> {
    return this.apiService.get<string>(`${environment.url.prefixIdentity}privacy-policy/update-date`);
  }

  public acceptPrivacyPolicy(): Observable<void> {
    return this.apiService.post<void>(`${environment.url.prefixIdentity}privacy-policy/accepted-date`);
  }

  public isUserAcceptLegalTerms(legalTermsUpdatedDate: string): boolean {
    const userLegalTermsAcceptedDate: string = this.companiesService.userLegalTermsAcceptedDate;

    if (userLegalTermsAcceptedDate && legalTermsUpdatedDate) {
      const daysDiff = dayjs(dayjs.utc(userLegalTermsAcceptedDate)).diff(dayjs.utc(legalTermsUpdatedDate), 'minute');

      if (daysDiff < 0) {
        return false;
      }

      return true;
    }

    return true;
  }

  public isUserAcceptPrivacyPolicy(privacyPolicyUpdatedDate: string): boolean {
    const userPrivacyPolicyAcceptedDate: string = this.companiesService.userPrivacyPolicyAcceptedDate;

    if (userPrivacyPolicyAcceptedDate && privacyPolicyUpdatedDate) {
      const daysDiff = dayjs(dayjs.utc(userPrivacyPolicyAcceptedDate)).diff(dayjs.utc(privacyPolicyUpdatedDate), 'minute');

      if (daysDiff < 0) {
        return false;
      }

      return true;
    }

    return true;
  }

  public redirectToLegalTermsAndPolicyConfirm(
    isUserAcceptLegalTerms: boolean,
    isUserAcceptPrivacyPolicy: boolean,
    redirect?: boolean,
  ): void {
    const redirectUrl: string = redirect ? this.location.path() : '/';
    if (!isUserAcceptLegalTerms && isUserAcceptPrivacyPolicy) {
      this.router.navigate(['/legal-terms', 'confirm'], {
        queryParams: { redirect: redirectUrl },
      });
      return;
    }

    if (isUserAcceptLegalTerms && !isUserAcceptPrivacyPolicy) {
      this.router.navigate(['/privacy-policy', 'confirm'], {
        queryParams: { redirect: redirectUrl },
      });
      return;
    }

    if (!isUserAcceptLegalTerms && !isUserAcceptPrivacyPolicy) {
      this.router.navigate(['/legal-terms', 'confirm-terms-and-privacy'], {
        queryParams: { redirect: redirectUrl },
      });
      return;
    }
  }
}
